import { ethers } from "ethers";
// burnValidator,
//     getValidatorOwner,
//     getValidatorBalance,

export const approveBurnValidator = async (validatorContract, posNftContract) => {
    let approveTx = await posNftContract.setApprovalForAll(
        validatorContract.address,
        true
    );
    return approveTx.wait();

    // return new Promise((resolve) => {
    //     setTimeout(() => {
    //         resolve(true);
    //     }, 2000);
    // }
    // );
}

export const isValidatorBurnApproved = async (account, validatorContract, posNftContract) => {
    let approved = await posNftContract.isApprovedForAll(
        account,
        validatorContract.address
    );
    return approved;
    // return false;
}

export const burnValidator = async (validatorContract, posNftContract) => {
    let burnTx = await validatorContract.burnValidator();
    return burnTx.wait();

    // return true;
    // return new Promise((resolve) => {
    //     setTimeout(() => {
    //         resolve(true);
    //     }, 2000);
    // });
}
export const getValidatorOwner = async (posNftContract) => {
    let validatorOwner = await posNftContract.ownerOf(1);
    return validatorOwner;
    // return "0xd8931CF00bf3f4Fd80D1C29c09929c7Fdf3F8616";
    // return "0xAA";
};

export const getValidatorBalance = async (stETHContract, posNftContract) => {
    // let validatorBalance = await stETHContract.balanceOf(
    //     posNftContract.address
    // );
    // validatorBalance = ethers.utils.formatUnits(validatorBalance, 18);
    // validatorBalance = validatorBalance.split(".")[0];
    // validatorBalance = validatorBalance.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    // return validatorBalance;
}

export const isValidatorActive = async (validatorContract) => {
    // let validatorActive = await validatorContract.validatorActive();
    // return validatorActive;
    return true;
}